<template>
  <div class="amap-container">
    <el-amap
      :vid="'amap-vue'"
      :center="center"
      :zooms="zooms"
      :zoom="zoom"
      :map-manager="amapManager"
      :animateEnable="false"
      :events="mapEvents">
        <el-amap-marker
          v-for="(marker, index) in markInner"
          :key="marker.id"
          :content="'<div class=\'marker ' + marker.level + '\'><div style=\'display: none;\' class=\'id\'>'+ marker.id +'</div><div style=\'display: none;\' class=\'name\'>'+ marker.name +'</div><div style=\'display: none;\' class=\'level\'>'+ marker.level +'</div><div style=\'display: none;\' class=\'lat\'>'+ marker.latitudeGD +'</div><div style=\'display: none;\' class=\'lot\'>'+ marker.longitudeGD +'</div></div>'"
          :position="[marker['longitudeGD'], marker['latitudeGD']]"
          :events="cityEvents">
        </el-amap-marker>
      <el-amap-info-window
        :position="window.position"
        :content="window.content"
        :visible="window.visible"
        :events="window.events"
        :offset="[250, 110]">
      </el-amap-info-window>
      <el-amap-polyline :editable="polyline.editable"  :path="polyline.path" :events="polyline.events" :strokeColor="'#ff3e4c'"></el-amap-polyline>
    </el-amap>
    <div class="title">智慧公证
      <div class="sj"></div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { AMapManager } from 'vue-amap'
  import mapObj from '../map/getMap'
  import line from '../line'
  let amapManager = new AMapManager()
  const POLYGON_ID = 'POLYGON_ID'
  export default {
    name: 'amap',
    data () {
      return {
        transitionName: 'slide-left',
        markInner: [
          {
            name: '',
            id: '',
            leve: '',
            latitudeGD: 31.117393,
            longitudeGD: 121.456639
          }
        ],
        toStreet: 14,
        toLaw: 14,
        amapManager: amapManager,
        center: [121.436816965957, 31.187615743114],
        polyline: {
          vid: POLYGON_ID,
          path: line,
          events: {
            click (e) {
              alert('click polyline')
            },
            end: (e) => {
            }
          },
          editable: false
        },
        zooms: [13, 18],
        window: {
          position: [121.5273285, 31.21515044],
          content: 'Hi! I am here!',
          visible: false,
          events: {
            close: () => {
              this.window.visible = false
            }
          }
        },
        mapEvents: {
          /**
           * 地图加载完触发
           */
          complete: () => {
            let map = this.amapManager.getMap()
            mapObj.map = mapObj.getMap(map)
            // if (this.zoom >= this.toStreet && this.zoom < this.toLaw) {
            //   this.mouseWheel(map)
            // }
            // map.setZoomAndCenter(14, [121.436816965957, 31.187615743114])
            // this.$store.dispatch('getClostLoad')
          },
          /**
           * 改变地图层级触发
           */
          zoomchange: () => {
            // let map = this.amapManager.getMap()
            if (this.zoom <= 16) {
              this.window.visible = false
            }
            // this.$store.commit('COM_ZOOM', map.getZoom())
          },
          /**
           * 鼠标滚轮开始时触发
           */
          mousewheel: () => {
          //  let map = this.amapManager.getMap()
          //  if (this.zoom >= this.toStreet && this.zoom < this.toLaw) {
          //    this.mouseWheel(map)
          //  } else if (this.zoom < this.toStreet && this.zoom > 12) {
          //    this.$store.dispatch('getTotalClear')
          //  } else if (this.zoom === 11 || this.zoom === 12) {
          //    return
          //  }
          },
          /**
           * 鼠标抬起时触发
           */
          mouseup: () => {
            let map = this.amapManager.getMap()
            if (this.zoom >= this.toStreet && this.zoom < this.toLaw) {
              this.mouseWheel(map)
            }
          }
        },
        cityEvents: {
          /**
           * marker点击事件
           */
          click: (e) => {
            let id = e.target.Qi.contentDom.querySelector('.id').innerHTML
            this.$store.dispatch('getIdPosition', id)
            // let name = e.target.si.contentDom.querySelector('.name').innerHTML
            // let leve = e.target.si.contentDom.querySelector('.level').innerHTML
            // let lat = e.target.si.contentDom.querySelector('.lat').innerHTML
            // let lot = e.target.si.contentDom.querySelector('.lot').innerHTML
            // let arr = {
            //   leve: leve,
            //   typeName: name,
            //   lat: lat,
            //   long: lot,
            //   phone: '暂无电话',
            //   Id: id
            // }
            // mapObj.map.setZoomAndCenter(16, [arr.long, arr.lat])
            // this.card(arr)
            // this.$store.dispatch('getIdPosition', id)
            // this.$store.dispatch('getStreet', street)
            // this.amapManager.getMap().setZoomAndCenter(this.toStreet, [long, lat])
            // this.$store.commit('COM_ZOOM', this.toStreet)
          }
        }
      }
    },
    watch: {
      theMark () {
        setTimeout(() => {
          this.markInner = this.theMark
        }, 1000)
      },
      area () {
        if (this.area) {
          this.transitionName = 'slide-right'
        } else {
          this.transitionName = 'slide-left'
        }
      },
      searchWindow () {
        let cardInfo = {
          typeName: this.searchWindow.result.properties.name,
          inner: this.searchWindow.result.properties.name,
          phone: this.searchWindow.result.properties.ContactInfo || '暂无电话',
          address: this.searchWindow.result.properties.address || '暂无地址',
          Id: this.searchWindow.result.id,
          long: this.searchWindow.result.properties.longitudeGD,
          lat: this.searchWindow.result.properties.latitudeGD,
          leve: this.searchWindow.result.properties.level,
          time: this.searchWindow.result.properties.serviceTime || '暂无'
        }
        mapObj.map.setZoomAndCenter(16, [cardInfo.long, cardInfo.lat])
        this.card(cardInfo)
      }
    },
    computed: {
      ...mapGetters({
        area: 'area',
        theMark: 'stractMark',
        zoom: 'zoom',
        searchWindow: 'ToPosition',
        lawWindow: 'ToPositionM'
      })
    },
    methods: {
      mouseWheel (map) {
        map.getCity((data) => {
          console.log(1)
        })
      },
      card (cardInfo) {
        this.window.visible = true
        this.window.position = this.center = [cardInfo.long, cardInfo.lat]
        this.window.content = `<div class="info-bg ${cardInfo.leve}"><i class="iconfont icon-local"></i>${cardInfo.typeName}</div><div class="info-body"><ul><li><span>联系地址:</span><span class="inner">${cardInfo.address}</span></li><li><span>联系电话:</span><span class="inner">${cardInfo.phone}</span></li><li><span>服务范围:</span><span class="inner">法律援助  人民调解</span></li><li><span>工作时间:</span><span class="inner">${cardInfo.time}</span></li></ul><div class="img-warp"><div class="img-bg" style="background: url('https://sh.12348.gov.cn/service/rest/tk.File/2ffaece64f554f5ea6d3886aa796e19e/') no-repeat; background-size: contain;"></div></div></div><a class="link" href="http://xuhui.sh.12348.gov.cn/sites/xuhui/org-detail.jsp?id=${cardInfo.Id}" target="_blank">查看详情</a>`
      }
    },
    created () {
      this.$store.dispatch('getMark')
      console.log(this.zoom)
      console.log(this.theMark)
    }
  }
</script>

<style lang="scss">
  @import '../assets/scss/variables';
  @import '../assets/scss/mixins';
  .amap-container {
    position: relative;
    width: 100%;
    height: 100%;
    .title {
      position: absolute;
      bottom: 0;
      right: 0;
      padding-left: 20px;
      padding-right: 20px;
      padding-top: 15px;
      padding-bottom: 15px;
      height: 80px;
      color: $white;
      font-size: 30px;
      font-weight: bolder;
      background: $brand;
      border-top: 1px solid #3a9bff;
      .sj {
        position: absolute;
        left: -60px;
        bottom: 0;
        width: 0;
        height: 0;
        border-bottom: 80px solid $brand;
        border-left: 60px solid transparent;
      }
    }
  }
  .marker {
    width: 19px;
    height: 33px;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    cursor: pointer;
    &.City {
      width: 59px;
      height: 73px;
      background-image: url(../../static/images/City.png);
    }
    &.County {
      width: 39px;
      height: 53px;
      background-image: url(../../static/images/County.png);
    }
    &.Street {
      width: 39px;
      height: 53px;
      background-image: url(../../static/images/Street.png);
    }
    &.Community {
      width: 15px;
      height: 15px;
      border-radius: 50%;
      background: $brand-green;
    }
  }
  .stract {
    background-color: #348ac7;
    &:hover {
      background-color: #0fa3b1;
      opacity: 1;
    }
  }
  .dot {
    width: 20px;
    height: 31px;
    background-image: url(../assets/images/mark_bs.png);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    cursor: pointer;
  }
  .amap-info-content {
    padding: 0;
    border: 0;
    a {
      display: block;
      width: 100%;
      height: 50px;
      text-align: center;
      border-top: 1px solid $gray-lighter;
      line-height: 50px;
      color: $gray-light;
      font-size: 16px;
    }
  }
  .amap-info-close {
    margin-top: $module-margin;
    margin-right: $module-margin;
    font-size: 24px;
    color: $white;
    cursor: pointer;
    &:hover {
      color: $white;
    }
  }
  .amap-info-outer, .amap-menu-outer {
    border-radius: $border-radius-base;
    box-shadow: 0 0 20px 0 rgba(0,0,0,0.1);
    &:hover {
      box-shadow: 0 0 20px 0 rgba(0,0,0,0.1);
    }
  }
  .amap-info-sharp {
    position: absolute;
    left: -15px;
    bottom: 0;
    top: 0;
    margin: auto;
    background: none;
    width: 0;
    height: 0;
    border-top: 15px solid transparent;
    border-right: 15px solid $white;
    border-bottom: 15px solid transparent;
  }
  .info-bg {
    position: relative;
    width: 450px;
    height: 60px;
    padding-left: 25px;
    padding-right: 25px;
    text-align: left;
    line-height: 60px;
    font-size: 22px;
    color: $white;
    &.City {
      background: #f53837;
    }
    &.County {
      background: #f4d038;
    }
    &.Street {
      background: #ef671b;
    }
    &.Community {
      background: #70bb4d;
    }
    i {
      margin-right: 10px;
      font-size: 22px;
    }
  }
  .info-body {
    width: 100%;
    height: 190px;
    background-color: $white;
    .img-warp {
      position: relative;
      height: 100%;
      width: 150px;
      .img-bg {
        position: absolute;
        left: 0;
        right: 0;
        top: 15px;
        margin: auto;
        width: 130px;
        height: 130px;
      }
    }
    ul {
      float: right;
      width: 314px;
      height: 100%;
      margin: 0;
      padding: 10px 15px 10px 15px;
      list-style: none;
      li {
        width: 100%;
        height: 25%;
        span {
          width: 25%;
          height: 100%;
          box-sizing: border-box;
          float: left;
          color: $gray-light;
          font-size: 16px;
          display: block;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
        .inner {
          padding-left: 5px;
          width: 75%;
          float: right;
          color: $gray-dark;
        }
      }
    }
  }
  .router-warp {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
  .slide-left-enter, .slide-right-leave-active {
    opacity: 0;
    -webkit-transform: translate(50px, 0);
    transform: translate(100%, 0);
  }
  .slide-left-leave-active, .slide-right-enter {
    opacity: 0;
    -webkit-transform: translate(-50px, 0);
    transform: translate(-100%, 0);
  }
</style>



// WEBPACK FOOTER //
// Amap.vue?bd52bdba